// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3BHVK","title":"Images90_title__U-wSs","images":"Images90_images__Cqgq1"};